'use client';

import LandingHero from '@/components/landing/LandingHero';
import TrustBar from '@/components/landing/TrustBar';
import TrendSection from '@/components/landing/TrendSection';
import TwoWaysSection from '@/components/landing/TwoWaysSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
import CustomerStoriesSection from '@/components/landing/CustomerStoriesSection';
import PersonaTabsSection from '@/components/landing/PersonaTabsSection';
import PricingPreviewSection from '@/components/landing/PricingPreviewSection';
import CTASection from '@/components/landing/CTASection';
import Footer from '@/components/landing/Footer';

export default function HomePage() {
  return (
    <div className="flex flex-col">
      <LandingHero />
      <TrustBar />
      <TrendSection />
      <TwoWaysSection />
      <HowItWorksSection />
      <CustomerStoriesSection />
      <PersonaTabsSection />
      <PricingPreviewSection />
      <CTASection />
      <Footer />
    </div>
  );
}
